<template>
    <v-app class="white">
        <div class="logo-img-position">
          <img 
          src="@/assets/intro_logo.png"
          class="img-logo"> 
        </div>
        <div class="copyright-position">
            <img 
            src="@/assets/copyright.png"
            class="img-copyright"> 
        </div>        
    </v-app>
</template>
<script>
export default {
  created() {
  },
  data: () => ({
  }),
  methods : {
  }
}
</script>
<style scoped>
  * {
      margin: 0;
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
      padding: 0;
  }
  html, body {
    height: 100vh;
    width: 100vw;
  }
  .img-logo {
    height: 36.85vw;
    width: 63.9vw;
  }
  .logo-img-position {
    position: absolute;
    top: 39.6vh;
    left: 18.1vw;
  }
  .copyright-position {
    position: absolute;
    bottom: 4.2vh;
    left: 15.88889vw;
  }
  .img-copyright {
    height: auto;
    width: 68.5vw;
  }
</style>